/* @flow */
import { cloneDeep } from 'lodash';
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';
import RelatedUserSummary from 'entities/RelatedUserSummary';

export const RECIPIENT_PENDING = 'pending';
export const RECIPIENT_ATTENDING = 'yes';
export const RECIPIENT_MAYBE = 'maybe';
export const RECIPIENT_DECLINED = 'no';

export type Attendance = 'yes' | 'maybe' | 'pending' | 'no';

export default class ActivityRecipient extends Entity {
  initialize() {
    this.idAttribute = 'uuid';
  }

  parse(response: Object): Object {
    const recipient = cloneDeep(response);

    if ('created_at' in recipient) {
      recipient['created_at'] = new Date(recipient['created_at']);
    }

    if ('user' in recipient) {
      recipient['user'] = new RelatedUserSummary(recipient['user']);
    }

    return recipient;
  }

  getActivityUuid(): string {
    return this.get('activity_uuid');
  }

  getUserUuid(): string {
    return this.get('user_uuid');
  }

  getCreatedAt(): Date {
    return this.get('created_at');
  }

  getAttendance(): string {
    return this.get('attendance');
  }

  getName(): string {
    return this.get('name');
  }

  getAddress(): ?string {
    return this.get('address');
  }

  hasPaid(): boolean {
    return this.get('paid');
  }

  getUser(): ?RelatedUserSummary {
    return this.get('user');
  }

  getNote(): ?string {
    return this.get('note');
  }

  static patch(activityId: string, recipientId: string, data: Object) {
    return apiRequest(
      `/activities/${activityId}/recipient_response/${recipientId}`,
      'PATCH',
      data
    ).then(response => ActivityRecipient.fromJSON(response));
  }

  claim(): Promise<ActivityRecipient> {
    return apiRequest(`/payments/recipients/${this.id}/claim`, 'POST').then(
      recipient => ActivityRecipient.fromJSON(recipient)
    );
  }
}



// WEBPACK FOOTER //
// ./src/entities/ActivityRecipient.js